import { UUID } from 'v2/core/entities/uuid';

export const isSavedAnalysis = (analysisID: UUID) => {
  return analysisID !== '';
};
